export default __webpack_public_path__ + "a58f17b31b1606a0a818d887ec5aac96.gif";